"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toast = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const utils_1 = require("../utils");
const useTimer_1 = require("../hooks/useTimer");
const useFocusReturn_1 = require("../hooks/useFocusReturn");
const react_transition_group_1 = require("react-transition-group");
const ToastContainer_1 = __importDefault(require("./ToastContainer"));
const Typography_1 = __importDefault(require("../Typography"));
const IcClose_1 = __importDefault(require("../Icons/IcClose"));
const IcCheckCircle_1 = __importDefault(require("../Icons/IcCheckCircle"));
const ButtonCircular_1 = __importDefault(require("../ButtonCircular"));
const ButtonV2_1 = __importDefault(require("../ButtonV2"));
const Link_1 = __importDefault(require("../Link"));
const constants_1 = require("./constants");
const Toast = (props) => {
    const { containerProps, className, id, message, show, closeButtonAriaLabel = 'Close Notification', onHide, responsiveLayout = true, icon, showIcon, iconClassName, actionButtonText, onClickActionButton, actionButtonClassName, actionButtonAriaLabel, linkText, linkUrl, openLinkInNewTab, linkTextClassName, linkProps, hideDuration = 20000, autoDismiss = true, returnFocusOnClose = true } = props, restProps = __rest(props, ["containerProps", "className", "id", "message", "show", "closeButtonAriaLabel", "onHide", "responsiveLayout", "icon", "showIcon", "iconClassName", "actionButtonText", "onClickActionButton", "actionButtonClassName", "actionButtonAriaLabel", "linkText", "linkUrl", "openLinkInNewTab", "linkTextClassName", "linkProps", "hideDuration", "autoDismiss", "returnFocusOnClose"]);
    const toastRef = react_1.useRef(null);
    utils_1.useHandleEscapeBtn(onHide);
    useFocusReturn_1.useFocusReturn({
        isOpen: show,
        shouldReturnFocus: returnFocusOnClose
    });
    const { startTimer, clearTimer, pauseTimer, resumeTimer } = useTimer_1.useTimer(onHide, hideDuration);
    react_1.useEffect(() => {
        if (autoDismiss && show) {
            startTimer();
        }
        return () => clearTimer();
    }, [hideDuration, show, autoDismiss]);
    const toastBaseClassName = 'bds-c-toast';
    const charLimitReached = message.length > constants_1.CHAR_LIMIT;
    const toastClassName = classnames_1.default(toastBaseClassName, className, {
        [`${toastBaseClassName}--responsive`]: responsiveLayout && charLimitReached
    });
    const toastIconClassName = classnames_1.default(`${toastBaseClassName}__icon`, iconClassName);
    const toastContentClassName = classnames_1.default(`${toastBaseClassName}__content`);
    const toastMessageClassName = classnames_1.default(`${toastBaseClassName}__message`);
    const toastActionButtonClassName = classnames_1.default(`${toastBaseClassName}__btn-action`, actionButtonClassName);
    const toastLinkTextClassName = classnames_1.default(`${toastBaseClassName}__link`, linkTextClassName);
    const getMessageElement = (message, linkText, linkUrl) => {
        if (!linkText || !linkUrl) {
            return message;
        }
        const linkElement = (react_1.default.createElement(Link_1.default, Object.assign({}, linkProps, { href: linkUrl, target: openLinkInNewTab ? '_blank' : '_self', rel: openLinkInNewTab ? 'noreferrer noopener' : '', className: toastLinkTextClassName, color: 'white' }), linkText));
        if (!message.includes(linkText)) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                message,
                "\u00A0",
                linkElement));
        }
        const messageParts = message.split(linkText);
        return messageParts.map((messageSubText, index) => {
            if (index === messageParts.length - 1) {
                return messageSubText;
            }
            return (react_1.default.createElement(react_1.Fragment, { key: messageSubText + index },
                messageSubText,
                "\u00A0",
                linkElement,
                "\u00A0"));
        });
    };
    const toastIcon = icon ? (react_1.default.createElement("div", { className: toastIconClassName }, icon)) : (react_1.default.createElement("div", { className: toastIconClassName },
        react_1.default.createElement(IcCheckCircle_1.default, { width: 24, height: 24, fill: 'white' })));
    const actionButton = actionButtonText ? (react_1.default.createElement(ButtonV2_1.default, { buttonCursorCustomClassName: toastActionButtonClassName, onClick: onClickActionButton, ariaLabel: actionButtonAriaLabel ? actionButtonAriaLabel : actionButtonText, variant: 'secondary-reversed', size: 'small' }, actionButtonText)) : null;
    return (react_1.default.createElement(ToastContainer_1.default, Object.assign({}, containerProps),
        react_1.default.createElement(react_transition_group_1.CSSTransition, { nodeRef: toastRef, in: show, timeout: 600, classNames: `${toastBaseClassName}-`, unmountOnExit: true },
            react_1.default.createElement("div", Object.assign({ ref: toastRef, id: id, className: toastClassName, onMouseEnter: pauseTimer, onMouseLeave: resumeTimer }, restProps),
                showIcon ? toastIcon : null,
                react_1.default.createElement("div", { className: toastContentClassName },
                    react_1.default.createElement(Typography_1.default, { as: 'span', type: 'label-lg', className: toastMessageClassName }, getMessageElement(message, linkText, linkUrl)),
                    actionButton),
                react_1.default.createElement(ButtonCircular_1.default, { ariaLabel: closeButtonAriaLabel, className: `${toastBaseClassName}__dismiss`, onClick: onHide, onFocus: pauseTimer, onBlur: resumeTimer },
                    react_1.default.createElement(IcClose_1.default, null))))));
};
exports.Toast = Toast;
exports.default = exports.Toast;
